/* eslint-disable no-useless-escape */
// eslint-disable-next-line no-undef
tinymce.addI18n("it", {
  Redo: "Ripristina",
  Undo: "Annulla",
  Cut: "Taglia",
  Copy: "Copia",
  Paste: "Incolla",
  "Select all": "Seleziona tutto",
  "New document": "Nuovo documento",
  Ok: "OK",
  Cancel: "Annulla",
  "Visual aids": "Aiuti visivi",
  Bold: "Grassetto",
  Italic: "Corsivo",
  Underline: "Sottolineato",
  Strikethrough: "Barrato",
  Superscript: "Apice",
  Subscript: "Pedice",
  "Clear formatting": "Cancella la formattazione",
  "Align left": "Allinea a sinistra",
  "Align center": "Allinea al centro",
  "Align right": "Allinea a destra",
  Justify: "Giustifica",
  "Bullet list": "Elenco puntato",
  "Numbered list": "Elenco numerato",
  "Decrease indent": "Riduci rientro",
  "Increase indent": "Aumenta rientro",
  Close: "Chiudi",
  Formats: "Formati",
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.":
    "Il browser non supporta l'accesso diretto alla cartella degli appunti. Usare i tasti di scelta rapida Ctrl+X/C/V.",
  Headers: "Intestazioni",
  "Header 1": "Intestazione 1",
  "Header 2": "Intestazione 2",
  "Header 3": "Intestazione 3",
  "Header 4": "Intestazione 4",
  "Header 5": "Intestazione 5",
  "Header 6": "Intestazione 6",
  Headings: "Titoli",
  "Heading 1": "Titolo 1",
  "Heading 2": "Titolo 2",
  "Heading 3": "Titolo 3",
  "Heading 4": "Titolo 4",
  "Heading 5": "Titolo 5",
  "Heading 6": "Titolo 6",
  Preformatted: "Preformattato",
  Div: "Div",
  Pre: "Pre",
  Code: "Codice",
  Paragraph: "Paragrafo",
  Blockquote: "Blockquote",
  Inline: "In linea",
  Blocks: "Blocchi",
  "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.":
    "Incolla \u00e8 in modalit\u00e0 testo normale. I contenuti sono incollati come testo normale se non disattivi l'opzione.",
  Fonts: "Caratteri",
  "Font Sizes": "Dimensioni caratteri",
  Class: "Classe",
  "Browse for an image": "Cerca un'immagine",
  OR: "OPPURE",
  "Drop an image here": "Rilasciare un'immagine qui",
  Upload: "Carica",
  Block: "Blocco",
  Align: "Allinea",
  Default: "Default",
  Circle: "Cerchio",
  Disc: "Disco",
  Square: "Quadrato",
  "Lower Alpha": "Alpha Minore",
  "Lower Greek": "Greek Minore",
  "Lower Roman": "Roman Minore",
  "Upper Alpha": "Alpha Superiore",
  "Upper Roman": "Roman Superiore",
  "Anchor...": "Ancoraggio...",
  Name: "Nome",
  Id: "Id",
  "Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.":
    "L'id dovrebbe cominciare con una lettera, seguito solo da lettere, numeri, linee, punti, virgole.",
  "You have unsaved changes are you sure you want to navigate away?":
    "Non hai salvato delle modifiche, sei sicuro di andartene?",
  "Restore last draft": "Ripristina l'ultima bozza.",
  "Special character...": "Carattere speciale...",
  "Source code": "Codice Sorgente",
  "Insert/Edit code sample": "Inserisci/Modifica esempio di codice",
  Language: "Lingua",
  "Code sample...": "Esempio di codice...",
  "Color Picker": "Selezione colori",
  R: "R",
  G: "G",
  B: "B",
  "Left to right": "Da Sinistra a Destra",
  "Right to left": "Da Destra a Sinistra",
  "Emoticons...": "Emoticon...",
  "Metadata and Document Properties": "Metadata e propriet\u00e0 del documento",
  Title: "Titolo",
  Keywords: "Parola Chiave",
  Description: "Descrizione",
  Robots: "Robot",
  Author: "Autore",
  Encoding: "Codifica",
  Fullscreen: "Schermo Intero",
  Action: "Azione",
  Shortcut: "Scorciatoia",
  Help: "Aiuto",
  Address: "Indirizzo",
  "Focus to menubar": "Focus sulla barra del menu",
  "Focus to toolbar": "Focus sulla barra degli strumenti",
  "Focus to element path": "Focus sul percorso dell'elemento",
  "Focus to contextual toolbar":
    "Focus sulla barra degli strumenti contestuale",
  "Insert link (if link plugin activated)":
    "Inserisci link (se il plugin link \u00e8 attivato)",
  "Save (if save plugin activated)":
    "Salva (se il plugin save \u00e8 attivato)",
  "Find (if searchreplace plugin activated)":
    "Trova (se il plugin searchreplace \u00e8 attivato)",
  "Plugins installed ({0}):": "Plugin installati ({0}):",
  "Premium plugins:": "Plugin Premium:",
  "Learn more...": "Per saperne di pi\u00f9...",
  "You are using {0}": "Stai usando {0}",
  Plugins: "Plugin",
  "Handy Shortcuts": "Scorciatoia pratica",
  "Horizontal line": "Linea Orizzontale",
  "Insert/edit image": "Aggiungi/Modifica Immagine",
  "Image description": "Descrizione Immagine",
  Source: "Fonte",
  Dimensions: "Dimenzioni",
  "Constrain proportions": "Mantieni Proporzioni",
  General: "Generale",
  Advanced: "Avanzato",
  Style: "Stile",
  "Vertical space": "Spazio Verticale",
  "Horizontal space": "Spazio Orizzontale",
  Border: "Bordo",
  "Insert image": "Inserisci immagine",
  "Image...": "Immagine...",
  "Image list": "Elenco immagini",
  "Rotate counterclockwise": "Ruota in senso antiorario",
  "Rotate clockwise": "Ruota in senso orario",
  "Flip vertically": "Rifletti verticalmente",
  "Flip horizontally": "Rifletti orizzontalmente",
  "Edit image": "Modifica immagine",
  "Image options": "Opzioni immagine",
  "Zoom in": "Ingrandisci",
  "Zoom out": "Rimpicciolisci",
  Crop: "Taglia",
  Resize: "Ridimensiona",
  Orientation: "Orientamento",
  Brightness: "Luminosit\u00e0",
  Sharpen: "Contrasta",
  Contrast: "Contrasto",
  "Color levels": "Livelli colore",
  Gamma: "Gamma",
  Invert: "Inverti",
  Apply: "Applica",
  Back: "Indietro",
  "Insert date/time": "Inserisci Data/Ora",
  "Date/time": "Data/Ora",
  "Insert/Edit Link": "Inserisci/modifica collegamento",
  "Insert/edit link": "Inserisci/Modifica Link",
  "Text to display": "Testo da Visualizzare",
  Url: "Url",
  "Open link in...": "Apri collegamento in...",
  "Current window": "Finestra corrente",
  None: "No",
  "New window": "Nuova Finestra",
  "Remove link": "Rimuovi link",
  Anchors: "Anchors",
  "Link...": "Collegamento...",
  "Paste or type a link": "Incolla o digita un collegamento",
  "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?":
    "L'URL inserito sembra essere un indirizzo email. Vuoi aggiungere il prefisso necessario mailto:?",
  "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?":
    "L'URL inserito sembra essere un collegamento esterno. Vuoi aggiungere il prefisso necessario http://?",
  "Link list": "Elenco link",
  "Insert video": "Inserisci Video",
  "Insert/edit video": "Inserisci/Modifica Video",
  "Insert/edit media": "Inserisci/Modifica Media",
  "Alternative source": "Alternativo",
  "Alternative source URL": "URL sorgente alternativa",
  "Media poster (Image URL)":
    "Poster dell'oggetto multimediale (URL dell'immagine)",
  "Paste your embed code below:": "Incolla il codice d'incorporamento qui:",
  Embed: "Incorporare",
  "Media...": "Oggetto multimediale...",
  "Nonbreaking space": "Spazio unificatore",
  "Page break": "Interruzione di pagina",
  "Paste as text": "incolla come testo",
  Preview: "Anteprima",
  "Print...": "Stampa...",
  Save: "Salva",
  Find: "Trova",
  "Replace with": "Sostituisci Con",
  Replace: "Sostituisci",
  "Replace all": "Sostituisci Tutto",
  Previous: "Indietro",
  Next: "Successivo",
  "Find and replace...": "Trova e sostituisci...",
  "Could not find the specified string.":
    "Impossibile trovare la parola specifica.",
  "Match case": "Maiuscole/Minuscole ",
  "Find whole words only": "Trova solo parole intere",
  "Spell check": "Controllo ortografia",
  Ignore: "Ignora",
  "Ignore all": "Ignora Tutto",
  Finish: "Termina",
  "Add to Dictionary": "Aggiungi al Dizionario",
  "Insert table": "Inserisci Tabella",
  "Table properties": "Propiet\u00e0 della Tabella",
  "Delete table": "Cancella Tabella",
  Cell: "Cella",
  Row: "Riga",
  Column: "Colonna",
  "Cell properties": "Propiet\u00e0 della Cella",
  "Merge cells": "Unisci Cella",
  "Split cell": "Dividi Cella",
  "Insert row before": "Inserisci una Riga Prima",
  "Insert row after": "Inserisci una Riga Dopo",
  "Delete row": "Cancella Riga",
  "Row properties": "Propriet\u00e0 della Riga",
  "Cut row": "Taglia Riga",
  "Copy row": "Copia Riga",
  "Paste row before": "Incolla una Riga Prima",
  "Paste row after": "Incolla una Riga Dopo",
  "Insert column before": "Inserisci una Colonna Prima",
  "Insert column after": "Inserisci una Colonna Dopo",
  "Delete column": "Cancella Colonna",
  Cols: "Colonne",
  Rows: "Righe",
  Width: "Larghezza",
  Height: "Altezza",
  "Cell spacing": "Spaziatura della Cella",
  "Cell padding": "Padding della Cella",
  "Show caption": "Mostra didascalia",
  Left: "Sinistra",
  Center: "Centro",
  Right: "Destra",
  "Cell type": "Tipo di Cella",
  Scope: "Campo",
  Alignment: "Allineamento",
  "H Align": "Allineamento H",
  "V Align": "Allineamento V",
  Top: "In alto",
  Middle: "In mezzo",
  Bottom: "In fondo",
  "Header cell": "cella d'intestazione",
  "Row group": "Gruppo di Righe",
  "Column group": "Gruppo di Colonne",
  "Row type": "Tipo di Riga",
  Header: "Header",
  Body: "Body",
  Footer: "Footer",
  "Border color": "Colore bordo",
  "Insert template...": "Inserisci modello...",
  Templates: "Template",
  Template: "Modello",
  "Text color": "Colore Testo",
  "Background color": "Colore Background",
  "Custom...": "Personalizzato...",
  "Custom color": "Colore personalizzato",
  "No color": "Nessun colore",
  "Remove color": "Rimuovi colore",
  "Table of Contents": "Tabella dei contenuti",
  "Show blocks": "Mostra Blocchi",
  "Show invisible characters": "Mostra Caratteri Invisibili",
  "Word count": "Conteggio parole",
  Count: "Conteggio",
  Document: "Documento",
  Selection: "Selezione",
  Words: "Parole",
  "Words: {0}": "Parole: {0}",
  "{0} words": "{0} parole",
  File: "File",
  Edit: "Modifica",
  Insert: "Inserisci",
  View: "Visualiza",
  Format: "Formato",
  Table: "Tabella",
  Tools: "Strumenti",
  "Powered by {0}": "Fornito da {0}",
  "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help":
    "Rich Text Area. Premi ALT-F9 per il men\u00f9. Premi ALT-F10 per la barra degli strumenti. Premi ALT-0 per l'aiuto.",
  "Image title": "Titolo immagine",
  "Border width": "Larghezza del bordo",
  "Border style": "Stile del bordo",
  Error: "Errore",
  Warn: "Avviso",
  Valid: "Valido",
  "To open the popup, press Shift+Enter":
    "Per aprire il popup, premere Shift+Invio",
  "Rich Text Area. Press ALT-0 for help.":
    "Area di testo RTF. Premere ALT-0 per la guida.",
  "System Font": "Carattere di sistema",
  "Failed to upload image: {0}": "Caricamento immagine fallito: {0}",
  "Failed to load plugin: {0} from url {1}":
    "Caricamento plugin fallito: {0} dall'URL {1}",
  "Failed to load plugin url: {0}": "Caricamento URL plugin fallito: {0}",
  "Failed to initialize plugin: {0}": "Inizializzazione plugin fallita: {0}",
  example: "esempio",
  Search: "Cerca",
  All: "Tutto",
  Currency: "Valuta",
  Text: "Testo",
  Quotations: "Citazioni",
  Mathematical: "Caratteri matematici",
  "Extended Latin": "Latino esteso",
  Symbols: "Simboli",
  Arrows: "Frecce",
  "User Defined": "Definito dall'utente",
  "dollar sign": "simbolo del dollaro",
  "currency sign": "simbolo di valuta",
  "euro-currency sign": "simbolo dell'euro",
  "colon sign": "simbolo del col\u00f3n",
  "cruzeiro sign": "simbolo del cruzeiro",
  "french franc sign": "simbolo del franco francese",
  "lira sign": "simbolo della lira",
  "mill sign": "simbolo del mill",
  "naira sign": "simbolo della naira",
  "peseta sign": "simbolo della peseta",
  "rupee sign": "simbolo della rup\u00eca",
  "won sign": "simbolo del won",
  "new sheqel sign": "simbolo del nuovo shekel",
  "dong sign": "simbolo del dong",
  "kip sign": "simbolo del kip",
  "tugrik sign": "simbolo del tugrik",
  "drachma sign": "simbolo della dracma",
  "german penny symbol": "simbolo del pfennig tedesco",
  "peso sign": "simbolo del peso",
  "guarani sign": "simbolo del guaran\u00ec",
  "austral sign": "simbolo dell'austral",
  "hryvnia sign": "simbolo della hryvnia",
  "cedi sign": "simbolo del cedi",
  "livre tournois sign": "simbolo della lira di Tours",
  "spesmilo sign": "simbolo dello spesmilo",
  "tenge sign": "simbolo del tenge",
  "indian rupee sign": "simbolo della rup\u00eca indiana",
  "turkish lira sign": "simbolo della lira turca",
  "nordic mark sign": "simbolo del marco nordico",
  "manat sign": "simbolo del manat",
  "ruble sign": "simbolo del rublo",
  "yen character": "simbolo dello yen",
  "yuan character": "simbolo dello yuan",
  "yuan character, in hong kong and taiwan":
    "simbolo dello yuan, Hong Kong e Taiwan",
  "yen/yuan character variant one": "simbolo yen/yuan variante uno",
  "Loading emoticons...": "Caricamento emoticon in corso",
  "Could not load emoticons": "Impossibile caricare emoticon",
  People: "Persone",
  "Animals and Nature": "Animali e natura",
  "Food and Drink": "Cibi e bevande",
  Activity: "Attivit\u00e0",
  "Travel and Places": "Viaggi e luoghi",
  Objects: "Oggetti",
  Flags: "Bandiere",
  Characters: "Caratteri",
  "Characters (no spaces)": "Caratteri (senza spazi)",
  "{0} characters": "{0} caratteri",
  "Error: Form submit field collision.":
    "Errore: Conflitto di campi nel modulo inviato.",
  "Error: No form element found.": "Errore: Nessun elemento di modulo trovato.",
  Update: "Aggiorna",
  "Color swatch": "Campione di colore",
  Turquoise: "Turchese",
  Green: "Verde",
  Blue: "Blu",
  Purple: "Viola",
  "Navy Blue": "Blu scuro",
  "Dark Turquoise": "Turchese scuro",
  "Dark Green": "Verde scuro",
  "Medium Blue": "Blu medio",
  "Medium Purple": "Viola medio",
  "Midnight Blue": "Blu notte",
  Yellow: "Giallo",
  Orange: "Arancio",
  Red: "Rosso",
  "Light Gray": "Grigio chiaro",
  Gray: "Grigio",
  "Dark Yellow": "Giallo scuro",
  "Dark Orange": "Arancio scuro",
  "Dark Red": "Rosso scuro",
  "Medium Gray": "Grigio medio",
  "Dark Gray": "Grigio scuro",
  "Light Green": "Verde chiaro",
  "Light Yellow": "Giallo chiaro",
  "Light Red": "Rosso chiaro",
  "Light Purple": "Viola chiaro",
  "Light Blue": "Azzurro",
  "Dark Purple": "Viola scuro",
  "Dark Blue": "Blu scuro",
  Black: "Nero",
  White: "Bianco",
  "Switch to or from fullscreen mode":
    "Attiva/disattiva la modalit\u00e0 schermo intero",
  "Open help dialog": "Apri la finestra di aiuto",
  history: "cronologia",
  styles: "stili",
  formatting: "formattazione",
  alignment: "allineamento",
  indentation: "indentazione",
  "permanent pen": "penna indelebile",
  comments: "commenti",
  "Format Painter": "Copia formattazione",
  "Insert/edit iframe": "Inserisci/modifica iframe",
  Capitalization: "Maiuscole/minuscole",
  lowercase: "minuscole",
  UPPERCASE: "MAIUSCOLE",
  "Title Case": "Iniziali Maiuscole",
  "Permanent Pen Properties": "Propriet\u00e0 penna indelebile",
  "Permanent pen properties...": "Propriet\u00e0 penna indelebile...",
  Font: "Carattere",
  Size: "Dimensione carattere",
  "More...": "Altro\u2026",
  "Spellcheck Language": "Lingua controllo ortografico",
  "Select...": "Seleziona...",
  Preferences: "Preferenze",
  Yes: "S\u00ec",
  No: "No",
  "Keyboard Navigation": "Navigazione tramite tastiera",
  Version: "Versione",
  Anchor: "Fissa",
  "Special character": "Carattere Speciale",
  "Code sample": "Esempio di codice",
  Color: "Colore",
  Emoticons: "Emoction",
  "Document properties": "Propriet\u00e0 Documento",
  Image: "Immagine",
  "Insert link": "Inserisci il Link",
  Target: "Target",
  Link: "Collegamento",
  Poster: "Anteprima",
  Media: "Media",
  Print: "Stampa",
  Prev: "Precedente",
  "Find and replace": "Trova e Sostituisci",
  "Whole words": "Parole Sbagliate",
  Spellcheck: "Controllo ortografico",
  Caption: "Didascalia",
  "Insert template": "Inserisci Template",
});
